export enum ModalCloseReason {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  CLOSE = 'CLOSE',
}
